// Thirdparty
import React, {useState} from 'react';
import ReactDom from 'react-dom';
// Components
import Countdown from "./../components/Countdown.js";
// Styles
import './../styles/SecurityVerification.css';
// Services
const Routes = require("../services/routes.js");

// Function to get 6 digit verification code. Fetch API to server.
async function fetchGetCode(){
  try{
    const url = Routes.getAuthVerifyURL();
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {"content-type": "application/json"},
        credentials: "include",
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch get code: ${response.statusText} Status:${response.status}`);

      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
      }
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    return result;
  }
  catch(err){
    console.error("Failed fetch get code: ", err);
  }
}

// Function to get 6 digit verification code. Fetch API to server.
async function fetchVerifyCode(code){
  try{
    const url = Routes.getAuthVerifyURL();
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);

    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: "include",
        body: JSON.stringify({code}),
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch get code: ${response.statusText} Status:${response.status}`);
      
      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
      }
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }

    return result;
  }
  catch(err){
    console.error("Failed signing up: ", err);
  }
}

function SecurityVerification() {
  const [code, setCode] = useState("");
  const [showCountdown, setShowCountdown] = useState(false);
  const [resendCode, setResendCode] = useState(false);

  function showErrorMessage(message){
    document.getElementById("sv-errorMessage").style.display = "inline";
    document.getElementById("sv-errorMessage").innerText = "* " + message;
  }

  const onClose = ()=>{
    window.location = "/";
  }

  const onCountdownEnd = ()=>{
    setShowCountdown(false);
    setResendCode(true);
  }

  const onGetCode = async () =>{
    setShowCountdown(true);

    const result = await fetchGetCode();
    if(result && !result.ok){
      showErrorMessage(result.message);
      onCountdownEnd();
    }
  }

  const onInputCode = async (event)=>{
    const value = event.target.value;
    if(!isNaN(+value) && value.length <= 6){
      setCode(value);
    }
  }

  const onSubmitCode = async (event) =>{
    event.preventDefault();

    const result = await fetchVerifyCode(code);
    if(result && !result.ok){
      showErrorMessage(result.message);
      onCountdownEnd();
    }
    else{
      window.location = "/";
    }
  }

  return(
    <div className="sv-fullscreen">
      <div className='sv-back-button' onClick={onClose}>
        <img src={require("./../assets/logo.svg").default} alt="logo" className="sv-logo"/>
      </div>

      <div className='sv-spacer'/>

      <div className="sv-container">
        <div className="sv-block">

          <div>
            <h2 className="sv-header">Security Verification</h2>
          </div>

          <p className="sv-details">To secure your account, please verify your email by competing the following verification.</p>

          <form className="sv-input-group" onSubmit={onSubmitCode}>
            <label htmlFor="mobile">Email Verification Code</label>
            <input type="text" className="sv-input-field" placeholder="Type your code"  value={code} onChange={onInputCode} required />
            {
              showCountdown
              ?
              <Countdown initialMinute={5} initialSeconds={0} onEnd={onCountdownEnd}/>
              :
              <button className="sv-getcode" onClick={onGetCode}>{resendCode ? "Resend Code":"Get Code"}</button>
            }
            <input type="submit" className="sv-submit-btn" value='SUBMIT' disabled={code.length!==6}/>
          </form>

          <div id="sv-errorDiv">
            <p id="sv-errorMessage">
              * Error message pending.
            </p>
          </div>
        
        </div>
      </div>
    </div>
  )

}

export default SecurityVerification;
